var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M15.333 23.3332H25.6551C26.285 23.3332 26.8208 22.8928 26.9087 22.2691C27.0858 21.0131 27.333 18.6734 27.333 15.3998C27.333 11.7277 27.0219 9.52446 26.8478 8.57862C26.7811 8.21684 26.6187 7.88247 26.372 7.60966C24.3585 5.38364 19.3535 1.6669 15.9477 0.794956C15.5435 0.691488 15.1225 0.691488 14.7184 0.794956C11.3125 1.6669 6.30755 5.38364 4.29404 7.60966C4.04727 7.88247 3.88487 8.21684 3.81825 8.57862C3.64407 9.52446 3.33301 11.7277 3.33301 15.3998C3.33301 18.6734 3.58022 21.0131 3.75728 22.2691C3.84521 22.8928 4.381 23.3332 5.01093 23.3332H15.333Z",
    fill: "#8AE27D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8709 23.3331H15.3333H11.3512C11.3401 22.7665 11.3333 22.1 11.3333 21.3183C11.3333 18.8284 11.4029 17.5064 11.4555 16.8629C11.4835 16.5208 11.6759 16.2263 12.0036 16.1239C12.5068 15.9666 13.456 15.7776 15.111 15.7776C16.7661 15.7776 17.7152 15.9666 18.2184 16.1239C18.5461 16.2263 18.7386 16.5208 18.7665 16.8629C18.8192 17.5064 18.8888 18.8284 18.8888 21.3183C18.8888 22.1 18.8819 22.7665 18.8709 23.3331Z",
    fill: "#2AB514"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 116",
    d: "M2.42337 2.42386C4.76652 0.0807174 8.56551 0.0807174 10.9087 2.42386C13.2518 4.76701 13.2518 8.566 10.9087 10.9091C9.33602 12.4818 8.0182 13.455 7.28649 13.9447C6.90707 14.1986 6.42496 14.1986 6.04554 13.9447C5.31383 13.455 3.99601 12.4818 2.42337 10.9091C0.0802292 8.566 0.0802292 4.76701 2.42337 2.42386Z",
    fill: "#2AB514"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 6.66602,
    cy: 6.6665,
    r: 2,
    fill: "#8AE27D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.05f7ed686c598c94bd6d3496adffa0b4.svg";
export { ForwardRef as ReactComponent };